document.addEventListener( 'DOMContentLoaded', function() {
	const countdownContainers = document.querySelectorAll( '.htr-countdown > ul' );

	if ( ! countdownContainers ) {
		return;
	}

	function get_remaining( endtime ) {
		const total = Date.parse( endtime ) - Date.parse( new Date() );
		const seconds = Math.floor( ( total / 1000 ) % 60 );
		const minutes = Math.floor( ( total / 1000 / 60 ) % 60 );
		const hours = Math.floor( ( total / ( 1000 * 60 * 60 ) ) % 24 );
		const days = Math.floor( total / ( 1000 * 60 * 60 * 24 ) );

		return {
			total,
			days,
			hours,
			minutes,
			seconds
		};
	}

	countdownContainers.forEach( function( countdown ) {
		const endtime = countdown.dataset.endtime;
		if ( ! endtime ) {
			return;
		}

		let days = countdown.querySelector( '.days' );
		let hours = countdown.querySelector( '.hours' );
		const minutes = countdown.querySelector( '.minutes' );
		const seconds = countdown.querySelector( '.seconds' );

		const reload_on_end = ( countdown.dataset.reload === 'true' );
		const remove_zeros = ( countdown.dataset.removeZeros === 'true' );

		function update_countdown() {
			const t = get_remaining( endtime );

			if ( days ) {
				days.innerHTML = `<span>${( '0' + t.days ).slice( -2 ).split('').join('</span><span>')}</span>`;
				if ( t.days <= 0 && remove_zeros ) {
					days.parentNode.nextElementSibling.remove();
					days.parentNode.remove();
					days = false;
				}
			}
			if ( hours ) {
				hours.innerHTML = `<span>${( '0' + t.hours ).slice( -2 ).split('').join('</span><span>')}</span>`;
				if ( t.hours <= 0 && remove_zeros ) {
					hours.parentNode.nextElementSibling.remove();
					hours.parentNode.remove();
					hours = false;
				}
			}
			minutes.innerHTML = `<span>${( '0' + t.minutes ).slice( -2 ).split('').join('</span><span>')}</span>`;
			seconds.innerHTML = `<span>${( '0' + t.seconds ).slice( -2 ).split('').join('</span><span>')}</span>`;

			if ( t.total <= 0 ) {
				clearInterval( timeinterval );

				if ( reload_on_end ) {
					setTimeout(
						function() {
							document.location.reload();
						},
						3000
					);
				}
			}
		}

		update_countdown();
		const timeinterval = setInterval( update_countdown, 1000 );
	} );
} );
